import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { MachineTypeService } from '../proxy/general/controllers/machine-type.service';
import { ReasonService } from '../proxy/general/controllers/reason.service';
import { EnergySourceService } from '../proxy/general/controllers/energy-source.service';
import { BrandService } from '../proxy/general/controllers/brand.service';
import { ModelService } from '../proxy/general/controllers/model.service';
import { Feller } from '@general/feller/feller';
import { Harvester } from '@general/harvester/harvester';
import { Forwarder } from '@general/forwarder/forwarder';
import { Tractor } from '@general/tractor/tractor';
import { VendorService, InternalOrderService } from '@controlling/proxy/controlling/controllers';

FieldBuilder.setNamespace('General');

export const MACHINE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('code', 'Entity.Machine.Code')
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('name', 'Entity.Machine.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .foreignKey('deactivationReasonId', 'Entity.Machine.DeactivationReason', ReasonService)
    .displayFromNested('deactivationReason.name')
    .sortBy('deactivationReason.name')
    .build(),
  FieldBuilder
    .date('deactivationDate', 'Entity.Machine.DeactivationDate')
    .build(),
  FieldBuilder
    .checkbox('isActive', 'Entity.Machine.IsActive')
    .build(),
  FieldBuilder
    .text('sapCode', 'Entity.Machine.SapCode')
    .maxLength(20)
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .display('fantasyName')
    .keyField('id')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('internalOrderId', 'Entity.InternalOrder', InternalOrderService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .text('notes', 'Entity.Machine.Notes')
    .maxLength(300)
    .build(),
  FieldBuilder
    .checkbox('ureaCheck', 'Entity.Machine.UreaCheck')
    .build(),
  FieldBuilder
    .checkbox('hasGps', 'Entity.Machine.HasGps')
    .build(),
  FieldBuilder
    .number('fabricationYear', 'Entity.Machine.FabricationYear')
    .build(),
  FieldBuilder
    .foreignKey('machineTypeId', 'Entity.MachineType', MachineTypeService)
    .required()
    .displayFromNested('machineType.name')
    .sortBy('machineType.name')
    .build(),
  FieldBuilder
    .foreignKey('energySourceId', 'Entity.EnergySource', EnergySourceService)
    .displayFromNested('energySource.name')
    .sortBy('energySource.name')
    .build(),
  FieldBuilder
    .foreignKey('brandId', 'Entity.Brand', BrandService)
    .displayFromNested('brand.name')
    .sortBy('brand.name')
    .build(),
  FieldBuilder
    .foreignKey('modelId', 'Entity.Model', ModelService)
    .displayFromNested('model.name')
    .sortBy('model.name')
    .build(),
];

export const MACHINE_CONFIG = {
  entityName: 'Machine',
  localizationKey: 'General::Entity.Machine',
  fields: MACHINE_FIELDS,
  permission: 'GeneralMachinesAndVehicles.Machines',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
  getChildren: (row: any, allChildren: any[]) => {
    const machineType = row?.machineType;
    if (!machineType) {
      return [];
    }
    const machineTypeName = machineType.entityName || machineType.name;
    if (!machineTypeName) {
      return [];
    }
    const lowerTypeName = machineTypeName.toLowerCase();
    return allChildren.filter(child => child.entityName.toLowerCase() === lowerTypeName);
  },
  children: [
      {
        entityName: 'Feller',
        foreignKeyField: 'machineId',
        localizationKey: 'General::Entity.Feller',
        component: Feller,
      },
      {
        entityName: 'Harvester',
        foreignKeyField: 'machineId',
        localizationKey: 'General::Entity.Harvester',
        component: Harvester,
      },
      {
        entityName: 'Forwarder',
        foreignKeyField: 'machineId',
        localizationKey: 'General::Entity.Forwarder',
        component: Forwarder,
      },
      {
        entityName: 'Tractor',
        foreignKeyField: 'machineId',
        localizationKey: 'General::Entity.Tractor',
        component: Tractor,
      },
    ]
};
